import { createAction } from '@reduxjs/toolkit';

export const UPDATE_CONTACT_ACTION_TYPE = 'saga/updateContact';
export const updateContactAction = createAction(UPDATE_CONTACT_ACTION_TYPE);
